/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2024 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */

export default {
	'Type something': 'Напишите что-либо',
	'About Jodit': 'О Jodit',
	'Jodit Editor': 'Редактор Jodit',
	"Jodit User's Guide": 'Jodit Руководство пользователя',
	'contains detailed help for using':
		'содержит детальную информацию по использованию',
	'For information about the license, please go to our website:':
		'Для получения сведений о лицензии , пожалуйста, перейдите на наш сайт:',
	'Buy full version': 'Купить полную версию',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'Авторские права © XDSoft.net - Чупурнов Валерий. Все права защищены.',
	Anchor: 'Анкор',
	'Open in new tab': 'Открывать ссылку в новой вкладке',
	'Open in fullsize': 'Открыть редактор в полном размере',
	'Clear Formatting': 'Очистить форматирование',
	'Fill color or set the text color': 'Цвет заливки или цвет текста',
	Redo: 'Повтор',
	Undo: 'Отмена',
	Bold: 'Жирный',
	Italic: 'Наклонный',
	'Insert Unordered List': 'Вставка маркированного списка',
	'Insert Ordered List': 'Вставить нумерованный список',
	'Align Center': 'Выровнять по центру',
	'Align Justify': 'Выровнять по ширине',
	'Align Left': 'Выровнять по левому краю',
	'Align Right': 'Выровнять по правому краю',
	'Insert Horizontal Line': 'Вставить горизонтальную линию',
	'Insert Image': 'Вставить изображение',
	'Insert file': 'Вставить файл',
	'Insert youtube/vimeo video': 'Вставьте видео',
	'Insert link': 'Вставить ссылку',
	'Font size': 'Размер шрифта',
	'Font family': 'Шрифт',
	'Insert format block': 'Вставить блочный элемент',
	Normal: 'Нормальный текст',
	'Heading 1': 'Заголовок 1',
	'Heading 2': 'Заголовок 2',
	'Heading 3': 'Заголовок 3',
	'Heading 4': 'Заголовок 4',
	Quote: 'Цитата',
	Code: 'Код',
	Insert: 'Вставить',
	'Insert table': 'Вставить таблицу',
	'Decrease Indent': 'Уменьшить отступ',
	'Increase Indent': 'Увеличить отступ',
	'Select Special Character': 'Выберите специальный символ',
	'Insert Special Character': 'Вставить специальный символ',
	'Paint format': 'Формат краски',
	'Change mode': 'Источник',
	Margins: 'Отступы',
	top: 'сверху',
	right: 'справа',
	bottom: 'снизу',
	left: 'слева',
	Styles: 'Стили',
	Classes: 'Классы',
	Align: 'Выравнивание',
	Right: 'По правому краю',
	Center: 'По центру',
	Left: 'По левому краю',
	'--Not Set--': '--не устанавливать--',
	Src: 'src',
	Title: 'Заголовок',
	Alternative: 'Альтернативный текст (alt)',
	Link: 'Ссылка',
	'Open link in new tab': 'Открывать ссылку в новом окне',
	file: 'Файл',
	Advanced: 'Расширенные',
	'Image properties': 'Свойства изображения',
	Cancel: 'Отмена',
	Ok: 'Ок',
	'Your code is similar to HTML. Keep as HTML?':
		'Ваш текст, который вы пытаетесь вставить похож на HTML. Вставить его как HTML?',
	'Paste as HTML': 'Вставить как HTML?',
	Keep: 'Сохранить оригинал',
	Clean: 'Почистить',
	'Insert as Text': 'Вставить как текст',
	'Insert only Text': 'Вставить только текст',
	'Word Paste Detected': 'Возможно это фрагмент Word или Excel',
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		'Контент который вы вставляете поступает из документа Microsoft Word / Excel. Вы хотите сохранить формат или очистить его?',
	'File Browser': 'Браузер файлов',
	'Error on load list': 'Ошибка при загрузке списка изображений',
	'Error on load folders': 'Ошибка при загрузке списка директорий',
	'Are you sure?': 'Вы уверены?',
	'Enter Directory name': 'Введите название директории',
	'Create directory': 'Создать директорию',
	'type name': 'введите название',
	'Drop image': 'Перетащите сюда изображение',
	'Drop file': 'Перетащите сюда файл',
	'or click': 'или нажмите',
	'Alternative text': 'Альтернативный текст',
	Browse: 'Сервер',
	Upload: 'Загрузка',
	Background: 'Фон',
	Text: 'Текст',
	Top: ' К верху',
	Middle: 'По середине',
	Bottom: 'К низу',
	'Insert column before': 'Вставить столбец до',
	'Insert column after': 'Вставить столбец после',
	'Insert row above': 'Вставить ряд выше',
	'Insert row below': 'Вставить ряд ниже',
	'Delete table': 'Удалить таблицу',
	'Delete row': 'Удалять ряд',
	'Delete column': 'Удалить столбец',
	'Empty cell': 'Очистить ячейку',
	source: 'HTML',
	bold: 'жирный',
	italic: 'курсив',
	brush: 'заливка',
	link: 'ссылка',
	undo: 'отменить',
	redo: 'повторить',
	table: 'таблица',
	image: 'Изображение',
	eraser: 'очистить',
	paragraph: 'параграф',
	fontsize: 'размер шрифта',
	video: 'видео',
	font: 'шрифт',
	about: 'о редакторе',
	print: 'печать',
	underline: 'подчеркнутый',
	strikethrough: 'перечеркнутый',
	indent: 'отступ',
	outdent: 'выступ',
	fullsize: 'во весь экран',
	shrink: 'обычный размер',
	hr: 'линия',
	ul: 'Список',
	ol: 'Нумерованный список',
	cut: 'Вырезать',
	selectall: 'Выделить все',
	'Embed code': 'Код',
	'Open link': 'Открыть ссылку',
	'Edit link': 'Редактировать ссылку',
	'No follow': 'Атрибут nofollow',
	Unlink: 'Убрать ссылку',
	Eye: 'Просмотр',
	pencil: 'Редактировать',
	Update: 'Обновить',
	' URL': 'URL',
	Edit: 'Редактировать',
	'Horizontal align': 'Горизонтальное выравнивание',
	Filter: 'Фильтр',
	'Sort by changed': 'По изменению',
	'Sort by name': 'По имени',
	'Sort by size': 'По размеру',
	'Add folder': 'Добавить папку',
	Reset: 'Восстановить',
	Save: 'Сохранить',
	'Save as ...': 'Сохранить как',
	Resize: 'Изменить размер',
	Crop: 'Обрезать размер',
	Width: 'Ширина',
	Height: 'Высота',
	'Keep Aspect Ratio': 'Сохранять пропорции',
	Yes: 'Да',
	No: 'Нет',
	Remove: 'Удалить',
	Select: 'Выделить',
	'Chars: %d': 'Символов: %d',
	'Words: %d': 'Слов: %d',
	All: 'Выделить все',
	'Select %s': 'Выделить: %s',
	'Select all': 'Выделить все',
	'Vertical align': 'Вертикальное выравнивание',
	Split: 'Разделить',
	'Split vertical': 'Разделить по вертикали',
	'Split horizontal': 'Разделить по горизонтали',
	Merge: 'Объединить в одну',
	'Add column': 'Добавить столбец',
	'Add row': 'Добавить строку',
	Delete: 'Удалить',
	Border: 'Рамка',
	'License: %s': 'Лицензия: %s',
	'Strike through': 'Перечеркнуть',
	Underline: 'Подчеркивание',
	superscript: 'верхний индекс',
	subscript: 'индекс',
	'Cut selection': 'Вырезать',
	Break: 'Разделитель',
	'Search for': 'Найти',
	'Replace with': 'Заменить на',
	Replace: 'Заменить',
	Paste: 'Вставить',
	'Choose Content to Paste': 'Выбрать контент для вставки',
	'You can only edit your own images. Download this image on the host?':
		'Вы можете редактировать только свои собственные изображения. Загрузить это изображение на ваш сервер?',
	'The image has been successfully uploaded to the host!':
		'Изображение успешно загружено на сервер!',
	palette: 'палитра',
	'There are no files': 'В данном каталоге нет файлов',
	Rename: 'Переименовать',
	'Enter new name': 'Введите новое имя',
	preview: 'Предпросмотр',
	download: 'Скачать',
	'Paste from clipboard': 'Вставить из буфера обмена',
	"Your browser doesn't support direct access to the clipboard.":
		'Ваш браузер не поддерживает прямой доступ к буферу обмена.',
	'Copy selection': 'Скопировать выделенное',
	copy: 'копия',
	'Border radius': 'Радиус границы',
	'Show all': 'Показать все',
	Apply: 'Применить',
	'Please fill out this field': 'Пожалуйста, заполните это поле',
	'Please enter a web address': 'Пожалуйста, введите веб-адрес',
	Default: 'По умолчанию',
	Circle: 'Круг',
	Dot: 'Точка',
	Quadrate: 'Квадрат',
	Find: 'Найти',
	'Find Previous': 'Найти Предыдущие',
	'Find Next': 'Найти Далее',
	'Insert className': 'Вставить название класса',
	'Press Alt for custom resizing':
		'Нажмите Alt для изменения пользовательского размера'
};
